'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _audioplayer = require('redux/modules/audioplayer');

var audioPlayerActions = _interopRequireWildcard(_audioplayer);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackDuration = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    humanizedPosition: state.audioplayer.humanizedPosition,
    playerAlbum: state.audioplayer.album,
    playerStatus: state.audioplayer.playerStatus,
    playerTracks: state.audioplayer.tracks
  };
}, (0, _extends3.default)({}, audioPlayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TrackDuration, _Component);

  function TrackDuration() {
    (0, _classCallCheck3.default)(this, TrackDuration);
    return (0, _possibleConstructorReturn3.default)(this, (TrackDuration.__proto__ || (0, _getPrototypeOf2.default)(TrackDuration)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrackDuration, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentTrackIndex = _props.currentTrackIndex,
          playerTracks = _props.playerTracks,
          playerStatus = _props.playerStatus,
          className = _props.className,
          track = _props.track,
          album = _props.album,
          playerAlbum = _props.playerAlbum,
          humanizedPosition = _props.humanizedPosition;

      var currentPlayerTrack = playerTracks[currentTrackIndex] || {};

      var _audioplayer$getPlayi = _AudioPlayer2.default.getPlayingInfo({
        track: track, album: album, playerAlbum: playerAlbum, currentPlayerTrack: currentPlayerTrack, playerStatus: playerStatus
      }),
          isActiveTrack = _audioplayer$getPlayi.isActiveTrack;

      return _react2.default.createElement(
        'div',
        { className: className },
        isActiveTrack ? humanizedPosition : track.durationTime
      );
    }
  }]);
  return TrackDuration;
}(_react.Component), _class2.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  currentTrackIndex: _propTypes2.default.number,
  humanizedPosition: _propTypes2.default.string,
  playerAlbum: _propTypes2.default.object,
  playerStatus: _propTypes2.default.string,
  playerTracks: _propTypes2.default.array,
  track: _propTypes2.default.object
}, _class2.defaultProps = {
  album: {},
  playerAlbum: {},
  track: {}
}, _temp)) || _class);
exports.default = TrackDuration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TrackDuration/TrackDuration.js
// module id = 2130
// module chunks = 1